<template>
    <div class="mb25 order__radio-group">
        <div v-if="isDelivToDoor">
            <input v-model="local_deliv_type_group" class="order__radio" id="home" name="delivery" value="todoor" type="radio" @change="setDeliveryType()"/>
            <label class="order__radio-label" for="home"><span class="order__radio-label-text">Доставка до двери</span></label>
        </div>
        <div v-if="isDelivPvz">
            <input v-model="local_deliv_type_group" class="order__radio" id="pickup" name="delivery" value="sam" type="radio" @change="setDeliveryType()"/>
            <label class="order__radio-label" for="pickup"><span class="order__radio-label-text">Пункты выдачи заказов</span></label>
        </div>
        <div v-if="isDelivOffice">
            <input v-model="local_deliv_type_group" class="order__radio" id="showroom" name="delivery" value="showroom" type="radio" @change="setDeliveryType()"/>
            <label class="order__radio-label" for="showroom"><span class="order__radio-label-text">Самовывоз из магазина <!--<sup class="order__radio-note order__radio-note--red">-3% скидка</sup>--></span></label>
        </div>
    </div>
</template>

<script>
    export default {
        name: "select-deliv-type",
        props: {
            deliv_mkad_allow: Boolean,
            deliv_over_mkad_allow: Boolean,
            office_deliv_allow: Boolean,
            pvz_exists: Boolean,
            deliv_type_group: String,
        },
        data () {
            return {
                local_deliv_mkad_allow: this.deliv_mkad_allow,
                local_deliv_over_mkad_allow: this.deliv_over_mkad_allow,
                local_office_deliv_allow: this.office_deliv_allow,
                local_pvz_exists: this.pvz_exists,
                local_deliv_type_group: this.deliv_type_group
            }
        },
        computed: {
            isDelivToDoor () {
                return this.local_deliv_mkad_allow || this.local_deliv_over_mkad_allow;
            },
            isDelivOffice () {
                return this.local_office_deliv_allow;
            },
            isDelivPvz () {
                return this.local_pvz_exists;
            },
        },
        methods: {
            setDeliveryType () {
                this.$store.dispatch('setDelivTypeGroup', this.local_deliv_type_group)
            }
        },
        mounted () {
            this.$store.commit('SET_DELIV_TYPE_GROUP', this.local_deliv_type_group)
            //Event.fire('changedDelivTypeGroup', this.local_deliv_type_group);
        }

    }
</script>

<style scoped>

</style>
